
<template>
  <div id="fenximenu">
    <span class="aaa" :class="{ active: now == 1 }" @click="clickMenu(1)">
      当年费用
    </span>
    <span class="aaa" :class="{ active: now == 2 }" @click="clickMenu(2)">
      当月费用
    </span>
  </div>
</template>
<script>
export default {
  data() {
    return {
      now: 1,
    };
  },
  methods: {
    clickMenu(v) {
      this.now = v;
      this.$emit('now',v)
    },
  },
};
</script>
<style lang="">
#fenximenu span {
  font-size: 16px;
}
#fenximenu .aaa {
  margin-right: 20px;
}
/* router-link-exact-active router-link-active */
#fenximenu .active {
  padding-bottom: 4px;
  border-bottom: 2px solid #fff;
  font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/components/fenxi/feiyong/fenxiMenu.vue